import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useStore } from './store/useStore';
import { useProductsStore } from './store/productsStore';
import Header from './components/Header';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import SearchModal from './components/SearchModal';
import WhatsAppButton from './components/WhatsAppButton';
import LanguageSelector from './components/LanguageSelector';
import InstagramPopup from './components/InstagramPopup';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ContactPage from './pages/ContactPage';
import FavoritesPage from './pages/FavoritesPage';
import ShippingTrackingPage from './pages/ShippingTrackingPage';
import PaymentPage from './pages/PaymentPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentFailedPage from './pages/PaymentFailedPage';
import AccountPage from './pages/AccountPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';

// Admin
import AdminLayout from './admin/AdminLayout';
import AdminLogin from './admin/pages/AdminLogin';
import AdminDashboard from './admin/pages/AdminDashboard';
import AdminProducts from './admin/pages/AdminProducts';
import AdminOrders from './admin/pages/AdminOrders';
import AdminCustomers from './admin/pages/AdminCustomers';
import AdminCategories from './admin/pages/AdminCategories';
import AdminSettings from './admin/pages/AdminSettings';
import AdminCoupons from './admin/pages/AdminCoupons';

import './i18n';

function App() {
  const { language, setLanguage } = useStore();
  const fetchProducts = useProductsStore((state) => state.fetchProducts);
  const fetchCategories = useProductsStore((state) => state.fetchCategories);
  const fetchShippingSettings = useProductsStore((state) => state.fetchShippingSettings);
  const startPolling = useProductsStore((state) => state.startPolling);

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
    fetchShippingSettings();
    // Admin panelinde yapılan değişiklikler (fiyat, görsel, isim, stok,
    // kategori, kargo ayarları — hepsi) sitede anlık görünsün diye arka
    // planda düzenli aralıklarla senkronize ediyoruz.
    const stopPolling = startPolling();
    return stopPolling;
  }, [fetchProducts, startPolling]);

  return (
    <Router>
      <div className="min-h-screen bg-white font-sans">
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="customers" element={<AdminCustomers />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="coupons" element={<AdminCoupons />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Public Routes */}
          <Route
            path="*"
            element={
              <>
                <Header />
                <main>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/magaza" element={<ShopPage />} />
                    <Route path="/iletisim" element={<ContactPage />} />
                    <Route path="/favorilerim" element={<FavoritesPage />} />
                    <Route path="/kargo-takip" element={<ShippingTrackingPage />} />
                    <Route path="/odeme" element={<PaymentPage />} />
                    <Route path="/odeme/basarili" element={<PaymentSuccessPage />} />
                    <Route path="/odeme/basarisiz" element={<PaymentFailedPage />} />
                    <Route path="/hesabim" element={<AccountPage />} />
                    <Route path="/urun/:id" element={<ProductDetailPage />} />
                    <Route path="/gizlilik-politikasi" element={<PrivacyPolicyPage />} />
                    <Route path="/kullanim-kosullari" element={<TermsPage />} />
                  </Routes>
                </main>
                <Footer />
                <CartDrawer />
                <SearchModal />
                <WhatsAppButton />
                <LanguageSelector />
                <InstagramPopup />
                <CookieConsent />
              </>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
